import { concatMap, tap, map } from 'rxjs/operators';
import { CrudServiceBase, RxUtils, TypeUtils } from '@utils';
import { httpService, logger } from '@services';
import { CarModel } from './car-model.class';

export class CarModelService extends CrudServiceBase<CarModel> {
	constructor() {
		super(CarModel, 'car-model');
	}

	getAllBrands() {
		return httpService.get<Partial<CarModel>[]>(this.getUrl(), 'brand').pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getAllBrands.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(CarModel, result))
		);
	}

	getAllModels(brand: string) {
		return httpService.get<Partial<CarModel>[]>(this.getUrl(), `brand/${brand}/model`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getAllModels.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(CarModel, result))
		);
	}

	getAllVersions(brand: string, model: string) {
		return httpService.get<Partial<CarModel>[]>(this.getUrl(), `brand/${brand}/model/${model}/version`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getAllVersions.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(CarModel, result))
		);
	}

	getImage(brand: string, model: string) {
		return httpService.get<string>(this.getUrl(), `images/${brand}/${model}`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getImage.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty')))
		);
	}

	getUniqueList() {
		return httpService.get<Record<string, Record<string, string[]>>>(this.getUrl(), `unique-list`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getUniqueList.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty')))
		);
	}
}

export const carModelService = new CarModelService();
